import React, { useState, useContext, useRef, useMemo, useEffect, useCallback } from "react";
import styles from "./PatternSidebar.styles.scss";
import { UserContext } from "../../App";
import { forceCheck } from "react-lazyload";
import PatternGrid from "./pattern-grid/PatternGrid";

const normalize = (value) =>
    (value ?? "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

const matchesSearch = (pattern, term) => {
    const q = normalize(term);
    if (!q) return true;
    return (
        normalize(pattern.name).includes(q) ||
        normalize(pattern.family).includes(q) ||
        normalize(pattern.collection).includes(q)
    );
};

const PatternSidebar = (props) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [active, setActive] = useState(false);
    const { isTotem } = useContext(UserContext);

    const { patterns } = props;

    useEffect(() =>{
        patterns.forEach((pattern) => {
            pattern.isLoading = true;
        });
        setTimeout(() => {
            setActive(true);
            forceCheck();
        }, 500);
    } ,[])

    const duratexYouPatterns = useMemo(
        () => patterns.filter((p) => p.duratex_you && (!searchTerm || matchesSearch(p, searchTerm))),
        [searchTerm, patterns]
    );

    const duratexPortfolioPatterns = useMemo(
        () => patterns.filter((p) => !p.duratex_you && (!searchTerm || matchesSearch(p, searchTerm))),
        [searchTerm, patterns]
    );

    return (
        <div
            onScroll={() => {
                forceCheck();
            }}
            className={`${
                active ? "pattern-sidebar active" : "pattern-sidebar"
            } ${isTotem ? "totem" : ""}`}
        >
            <div className="sidebar-header">
                <h3>Selecione um padrão</h3>
                <button
                    className="close-sidebar"
                    onClick={() => props.onClose()}
                >
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M29 12.8129L27.1871 11L20 18.1871L12.8129 11L11 12.8129L18.1871 20L11 27.1871L12.8129 29L20 21.8129L27.1871 29L29 27.1871L21.8129 20L29 12.8129Z"
                            fill="#919699"
                        />
                    </svg>
                </button>
            </div>
            {!isTotem && (
                <div className="input-wrapper">
                    <input
                        type="search"
                        autoComplete="no"
                        className="search-input"
                        placeholder="Pesquise por um padrão"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            )}


            <div className="space-y-24">
                {
                    duratexYouPatterns.length > 0 &&
                    <PatternGrid title="Padrões Duratex YOU" patterns={duratexYouPatterns} onClickPattern={props.onSelect} />
                }

                {
                    duratexPortfolioPatterns.length > 0 &&
                    <PatternGrid title="Padrões Portfólio Duratex" patterns={duratexPortfolioPatterns} onClickPattern={props.onSelect} />
                }
            </div>
        </div>
    );
};

export default PatternSidebar;
